import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";
import { UpdatePolicyModePayload, UpdatePolicyTimePayload, WhitelistDetails } from "../interface";

export const getProfiles = async (tenantName: string) => {

    const url = `${NGROK}/api/profiles/inherited?tenantName=${tenantName}`;
    const data = await apiClient({
        method: "GET",
        url,
    });
    return data.sort((a: any, b: any) => b.id - a.id);
}



export const updatePolicyMode = async (
    profileId: number,
    tenantName: string,
    mode: string
) => {
    const url = `${NGROK}/api/profiles/${profileId}/operation-mode`;

    const payload: UpdatePolicyModePayload =
        mode === "INHERITED_FROM_TENANT"
            ? { inheritedByTenantName: tenantName, mode }
            : { mode };

    try {
        const data = await apiClient({
            method: "PUT",
            url,
            data: payload,
        });

        return data;
    } catch (error) {
        console.error("Error updating policy mode:", error);
        throw error; // re-throw so caller can handle it
    }
};


export const updateGlobalOperatingMode = async (tenantName: string,
    newMode: string) => {
    const url = `${NGROK}/api/${tenantName}/operation-mode`;
    try {
        const data = await apiClient({
            method: "PUT",
            url,
            data: {
                mode: newMode,
            },
        });

        return data;
    } catch (error) {
        console.error("Error updating policy mode:", error);
        throw error;
    }

}


export const updatePolicyTime = async (
    profileId: number,
    defaultTime: number
) => {
    const url = `${NGROK}/api/profiles/update-time`;

    const payload: UpdatePolicyTimePayload = { profileId, defaultTime }

    try {
        const data = await apiClient({
            method: "PUT",
            url,
            data: payload,
        });

        return data;
    } catch (error) {
        console.error("Error updating policy time:", error);
        throw error; // re-throw so caller can handle it
    }
};


export const deleteCopiedProfiles = async (
    profileId: number
) => {
    const url = `${NGROK}/api/profiles/delete-copied/${profileId}`;
    try {
        const data = await apiClient({
            method: "DELETE",
            url
        });

        return data;
    } catch (error) {
        console.error("Error deleting custom policy :", error);
        throw error; // re-throw so caller can handle it
    }
};



export const getCategoryItems = async (os: string, tenantName: string, selectedResourceType: string, name: string, profileId: number) => {
    if (os.toUpperCase() === "MAC" || os.toUpperCase() === "MACOS")
        os = "macos"

    let url = `${NGROK}/api/profiles/get-all-apps-and-os?profileId=${profileId}&categoryName=${name}&os=${os.toUpperCase()}&tenantName=${tenantName}`;

    if (selectedResourceType === "folder")
        url = `${NGROK}/api/computers/operation-system/get-all-folders?categoryName=${name}&os=${os.toUpperCase()}&tenantName=${tenantName}`;
    else if (selectedResourceType === "url")
        url = `${NGROK}/api/computers/operation-system/get-all-url-control?categoryName=${name}&os=${os.toUpperCase()}&tenantName=${tenantName}`;

    try {
        const data = await apiClient({
            method: "GET",
            url
        });

        return data;
    } catch (error) {
        console.error("Error deleting custom policy :", error);
        throw error; // re-throw so caller can handle it
    }

}

export const fetchCategories = async (os: string, tenantName: string, selectedResourceType: string) => {
    let type = "for-apps";
    if (selectedResourceType === "folder")
        type = "for-folders";
    else if (selectedResourceType === "url")
        type = "for-url-control";


    if (os.toUpperCase() === "MAC" || os.toUpperCase() === "MACOS")
        os = "macos"

    const url = `${NGROK}/api/category/${type}?tenantName=${tenantName}&os=${os.toUpperCase()}`;

    try {
        const data = await apiClient({
            method: "GET",
            url
        });

        return data.sort((a: any, b: any) => {
            const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
            const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;

            return dateB - dateA;
        });
    } catch (error) {
        console.error("Error deleting custom policy :", error);
        throw error; // re-throw so caller can handle it
    }

}

export const updateCategory = async (payload: any) => {
    let url = `${NGROK}/api/category`;
    const data = await apiClient({
        method: "PUT",
        url,
        data: payload
    });
    return data;
}

export const createPendingProfile = async (profileId: number, profileName: string) => {
    let url = `${NGROK}/api/profiles/create-pending`;
    let payload = {
        copyFromProfileId: profileId,
        newProfileName: profileName,
    }
    const data = await apiClient({
        method: "POST",
        url,
        data: payload
    });
    return data;

}


export const fetchPendingProfiles = async (tenantName: string) => {
    let url = `${NGROK}/api/profiles/get-pending?tenantName=${tenantName}`;

    const data = await apiClient({
        method: "GET",
        url
    });
    return data;

}


export const copyProfile = async (profileId: number, profileName: string) => {
    let url = `${NGROK}/api/profiles/copy`;
    let payload = {
        copyFromProfileId: profileId,
        newProfileName: profileName,
    }
    const data = await apiClient({
        method: "POST",
        url,
        data: payload
    });
    return data;

}

export const whiteListingDetails = async (profileId: number): Promise<WhitelistDetails> => {
    let url = `${NGROK}/api/getwhitelistdetailsByPolicyId/${profileId}`;

    const data = await apiClient({
        method: "GET",
        url
    });
    return data;
}


export const toggleEnableForWhiteList = async (profileId: number, enabled: boolean) => {
    let url = `${NGROK}/api/enableWhitelistingforpolicyid/${profileId}?isenabled=${enabled}`;

    const data = await apiClient({
        method: "PUT",
        url
    });
    return data;
}

export const toggleEnableForAgentUpdate = async (profileId: number, enabled: boolean) => {
    let url = `${NGROK}/api/updateAutoGenerateAgent/${profileId}?isenabled=${enabled}`;

    const data = await apiClient({
        method: "PUT",
        url
    });
    return data;
}


export const submitHashes = async (payload: any) => {
    let url = `${NGROK}/api/add-whitelistdetails`;

    const data = await apiClient({
        method: "POST",
        url,
        data: payload
    });
    return data;
}
export const deleteHashes = async (payload: any, profileId: number) => {
    let url = `${NGROK}/api/deleteHashesByPolicyId/${profileId}`;

    const data = await apiClient({
        method: "PUT",
        url,
        data: payload
    });
    return data;
}